import { render, staticRenderFns } from "./myPoint.vue?vue&type=template&id=1abd1ae2&"
import script from "./myPoint.vue?vue&type=script&lang=js&"
export * from "./myPoint.vue?vue&type=script&lang=js&"
import style0 from "./myPoint.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports